import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import {
    Http, i18n, BASE_URL,
    OAUTH2_CLIENT, OAUTH2_REDIRECT_URI,
} from 'common'

export class OAuth2Provider extends React.Component {
  static childContextTypes = {
    oauth: PropTypes.object.isRequired
  }

  state = {
    authorized: false,
    expired: false
  }

  getChildContext() {
    return { oauth: { reset: this.reset } }
  }

  reset = () => {
    this.setState({expired: true});
  }

  componentWillMount() {
    const channel = new BroadcastChannel('openid_admin_channel');
    channel.onmessage = (ev) => {
      const location = ev.data
      const params = qs.parse(location);

      const error = params.error || params['/error'];
      if (error) {
          if (error === 'login_required') {
              window.open(
                  `${BASE_URL}/authorize?client_id=${OAUTH2_CLIENT}&redirect_uri=${OAUTH2_REDIRECT_URI}&response_type=token&state=modal`,
                  '_blank'
              )
          }

          throw error;
      }

      const token = params.access_token || params['/access_token'];
      this.authorize(token)
    }

    this.refresh(
        `${BASE_URL}/authorize?client_id=${OAUTH2_CLIENT}&redirect_uri=${OAUTH2_REDIRECT_URI}&response_type=token&prompt=none`,
        '_blank'
    )
  }

  authorize = (token) => {
    Http.setBearerToken(token);
    this.setState({authorized: true, expired: false});
  }

  refresh = url => {
      const IFRAME_ID = 'silent-refresh-iframe';

      const oldFrame = document.getElementById(IFRAME_ID);

      if (oldFrame) {
          document.body.removeChild(old_iframe);
      }

      const iframe = document.createElement('iframe');
      iframe.id = IFRAME_ID
      iframe.style.display = 'none'
      iframe.setAttribute('src', url)

      document.body.appendChild(iframe)
  }

  render() {
      const {authorized, expired} = this.state
      return (
          <div>
              {expired &&
                  <div className="alert alert--error alert--no-margin">
                      <a href={`${OAUTH2_REDIRECT_URI}#authorize=1`} target='_blank'>
                          {i18n('error.token-expired')}
                      </a>
                  </div>
              }
              {authorized ? this.props.children : null}
          </div>
      )
  }
}
